package one.healthium.onboarding.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import org.koin.compose.viewmodel.koinViewModel

@Composable
internal fun UserDataProvider(
    content: @Composable (UserProfileUiModel, UserDataContract) -> Unit
) {
    val viewModel = koinViewModel<OnboardingViewModel>()
    val state by viewModel.state.collectAsState()

    content(state.userState, viewModel)
}
